import { mapStores } from 'pinia';
import { useAppStore } from '@/store/app';
export default {
  name: 'AppLoadingOverlay',
  computed: {
    ...mapStores(useAppStore),
    overlayVisible() {
      return !this.appStore.bootstrapReady;
    }
  },
  watch: {
    overlayVisible: {
      immediate: true,
      handler(visible) {
        document.body.classList.toggle('app-is-loading', visible);
      }
    }
  },
  beforeUnmount() {
    document.body.classList.remove('app-is-loading');
  },
  methods: {
    async retryBootstrap() {
      try {
        await this.appStore.initialize({
          force: true
        });
      } catch {
        // 请求层已反馈错误，覆盖层保留重试入口。
      }
    }
  }
};